// API Configuration
export const API_CONFIG = {
  BASE_URL: (process.env as any).REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
};

// Helper function to get auth token
export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken') ||
         localStorage.getItem('token') ||
         localStorage.getItem('access_token');
};

// Helper function to get auth headers
export const getAuthHeaders = (): { Authorization: string; 'Content-Type': string } => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Authentication required. Please log in.');
  }

  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

// API endpoints
export const API_ENDPOINTS = {
  CHAT: '/chat',
  HOTELS: '/hotels',
  CHAT_HISTORY: '/chat/history',
};